// extracted by mini-css-extract-plugin
export default {"notApplicable":"HomeSkillTrainingPage_notApplicable__PHc5G"};